/**
 * Artifact Renderer
 * Renders charts and tables from AI responses
 */

import AlertPane from "components/alert";
import Button from "components/button";
import { MdDownload, MdSave } from "react-icons/md";
import { ArtifactChart, ArtifactTable, exportTableCsv } from "./artifacts";

const ArtifactHeader = ({ title, children }) => (
  <div className="mb-2 flex items-center justify-between gap-2">
    <h4 className="min-w-0 truncate text-sm font-semibold text-fg">{title}</h4>
    <div className="flex shrink-0 items-center gap-1">{children}</div>
  </div>
);

const SaveButton = ({ artifact, onSave }) =>
  onSave ? (
    <Button variant="ghost" size="sm" leftIcon={<MdSave />} onClick={() => onSave(artifact)}>
      Save
    </Button>
  ) : null;

const ArtifactRenderer = ({ artifact, onSave }) => {
  if (!artifact || !artifact.data) {
    return null;
  }

  if (artifact.type === "chart") {
    return (
      <div className="rounded-control border border-line bg-surface p-3 text-fg">
        <ArtifactHeader title={artifact.data.title || "Chart"}>
          <SaveButton artifact={artifact} onSave={onSave} />
        </ArtifactHeader>
        <ArtifactChart id={artifact.id} data={artifact.data} />
      </div>
    );
  }

  if (artifact.type === "table") {
    return (
      <div className="text-fg">
        <ArtifactHeader title={artifact.data.title || "Table"}>
          <Button
            variant="ghost"
            size="sm"
            leftIcon={<MdDownload />}
            onClick={() => exportTableCsv(artifact.data)}
          >
            CSV
          </Button>
          <SaveButton artifact={artifact} onSave={onSave} />
        </ArtifactHeader>
        <ArtifactTable data={artifact.data} />
      </div>
    );
  }

  return (
    <AlertPane tone="warning" className="">
      Unknown artifact type: {artifact.type}
    </AlertPane>
  );
};

export default ArtifactRenderer;
